import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"l-wrapper_main\"><main class=\"p-login\"><div class=\"p-login-inner\"><h1 class=\"p-login-heading-2\">エラー</h1><div class=\"p-login-text-block --no-mt\"><p>この認証URLは有効ではございません。</p></div><div class=\"p-login-text-block\"><a class=\"p-recommend-button --type-2 --width-set-1 --has-icon t-decoration-none\" href=\"/login/\"><span>ログイン画面へ</span></a></div></div></main></div>", 1)
const _hoisted_3 = { class: "l-wrapper_nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityCertificationCompleteErrorView',
  setup(__props) {

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_6, 8, _hoisted_4)
    ])
  ]))
}
}

})